import { gql } from '@apollo/client';

export const UPDATE_NOTIFICATION = gql`
  mutation UpdateNotification($notificationId: String!) {
    updateNotification(notificationId: $notificationId) {
      id
    }
  }
`;
